import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';
import { fetchArtists } from '../lib/api';
import { useWishlist } from '../lib/useWishlist';
import { ArtistCard } from '../components/ArtistCard';

export default function Wishlist() {
  const { slugs } = useWishlist();
  const [artists, setArtists] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchArtists().then(all => setArtists(all.filter(a => slugs.includes(a.slug)))).finally(() => setLoading(false));
  }, [slugs]);

  return (
    <div data-testid="wishlist-page" className="bg-white">
      <section className="pt-32 pb-16 container-edge">
        <div className="text-[11px] uppercase tracking-[0.3em] text-[#eb5381]">Your Edit</div>
        <h1 className="mt-3 font-serif text-5xl md:text-7xl leading-[0.95] tracking-tight">
          The <span className="italic text-[#a465a8]">artists</span> you've saved.
        </h1>
      </section>
      <section className="container-edge pb-24">
        {loading ? (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {[0,1,2].map(i => <div key={i} className="aspect-[4/5] bg-[#f7f7f7] animate-pulse" />)}
          </div>
        ) : artists.length === 0 ? (
          <div className="border border-[#eaeaea] p-14 text-center" data-testid="wishlist-empty">
            <Heart className="w-10 h-10 mx-auto text-[#eb5381]" />
            <h2 className="mt-6 font-serif text-3xl md:text-4xl">Your wishlist is empty.</h2>
            <p className="mt-3 text-neutral-600 max-w-md mx-auto">Tap the heart on any artist card to save them here for later.</p>
            <Link to="/artists" className="mt-8 inline-flex items-center justify-center bg-[#eb5381] hover:bg-[#d64570] text-white px-8 py-3 text-[11px] uppercase tracking-[0.25em] transition-colors">
              Browse Artists
            </Link>
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-14">
            {artists.map(a => <ArtistCard key={a.slug} artist={a} />)}
          </div>
        )}
      </section>
    </div>
  );
}
